//@todo template didnt generate lan env? remove chrome from template
import debug from "debug";
import React from 'react';
import ReactDOM from 'react-dom/client'
import App from './App';
import * as Sentry from '@sentry/browser';
import Logger from "./lib/SimpleLogger";
import dayjs from "dayjs";
import config from "./config";
import uiStore from "./lib/stores/uiStore";
import {configuration} from './configuration';
import duration from 'dayjs/plugin/duration';
//todo: fix couldn't access directory.. creating

dayjs.extend(duration);

const logger = new Logger("index.js");
window.debug = debug;

if (['prod', 'test'].includes(process.env.APP_ENV || "")) {
    Sentry.init({
        dsn: "https://280f6b536534479bb5229522bb6941da@sentry.io/1847225",
        release: 'shadow-chat@' + process.env.APP_VERSION,
        beforeSend: (event, hint) => {
            const error = hint.originalException || hint.syntheticException;
            if (!['prod', 'test'].includes(process.env.APP_ENV || "")) {
                console.error(error);
                return null; // this drops the event and nothing will be sent to sentry
            }
            return event;
        }
    });
}


if (process.env.NODE_ENV !== 'production') {
    logger.log('Looks like we are in development mode!');
}

logger.colorLog(`%c Starting Shadow Chat client v${config.appVersion}-${config.appEnv}.`, 'color: #008ce1; font-weight: 800');
logger.colorLog('Last commit message: ' + config.lastCommitMessage);
const rootEl = document.getElementById("root");

if (!rootEl) {
    throw new Error("Missing an element with id: root");
}

const root = ReactDOM.createRoot(rootEl);

window.uiStore = uiStore;

root.render(
        <App configuration={{
            ...configuration,
        }}/>
);
